import { render, staticRenderFns } from "./AuthStatement.vue?vue&type=template&id=02841581"
import script from "./AuthStatement.vue?vue&type=script&lang=js"
export * from "./AuthStatement.vue?vue&type=script&lang=js"
import style0 from "./AuthStatement.vue?vue&type=style&index=0&id=02841581&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports